const styles = theme => ({
  addDocumentsButton: {
    padding: theme.spacing.unit,
    position: 'absolute',
    right: 52
  },
  requiredDocumentRoot: {
    marginTop: -(theme.spacing.unit * 2),
    marginBottom: -(theme.spacing.unit * 2),
    '&:last-child': {
      marginBottom: 0
    }
  }
});

export default styles;
